// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCmW9lzL8XYeTRu-epmBBZemUADETA5f58",
  authDomain: "jposh-4046b.firebaseapp.com",
  projectId: "jposh-4046b",
  storageBucket: "jposh-4046b.appspot.com",
  messagingSenderId: "31697435860",
  appId: "1:31697435860:web:5a6d4c9049587e08becf41"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default app